import { Ic } from './Icon';
import { SectionHead, delay } from './Section';
import type { LandingContent } from './content';

export function Marquee({ c }: { c: LandingContent }) {
  const items = c.marquee.items.map((x) => (
    <span className="tech" key={x}>
      <Ic name="cpu" />
      {x}
    </span>
  ));
  return (
    <div className="marquee-wrap" data-reveal>
      <div className="lp-container">
        <div className="marquee-label">{c.marquee.label}</div>
      </div>
      <div className="marquee" aria-hidden="true">
        <div className="marquee-track">{items}</div>
        <div className="marquee-track">{items}</div>
      </div>
    </div>
  );
}

export function FeaturesSection({ c }: { c: LandingContent }) {
  return (
    <section className="lp-section" id="features">
      <div className="lp-container">
        <SectionHead eyebrow={c.features.eyebrow} title={c.features.title} sub={c.features.sub} />
        <div className="bento">
          {c.features.items.map((f, i) => (
            <article className={`lp-card feature${f.big ? ' span2' : ''}`} data-reveal key={f.tag} style={delay((i % 3) * 90)}>
              {f.spark ? (
                <svg className="spark" viewBox="0 0 120 44" aria-hidden="true" focusable="false">
                  <path className="area" d="M0 30 L15 26 L30 28 L45 18 L60 22 L75 12 L90 16 L105 8 L120 10 V44 H0Z" />
                  <path d="M0 30 L15 26 L30 28 L45 18 L60 22 L75 12 L90 16 L105 8 L120 10" />
                </svg>
              ) : null}
              <span className="ic">
                <Ic name={f.icon} />
              </span>
              <span className="tag">{f.tag}</span>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
              <ul>
                {f.hl.map((h) => (
                  <li key={h}>
                    <Ic name="check" />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
